export default __webpack_public_path__ + "static/residential-2c35dc8f6b4a81f3446f7d0a58a534b4.jpg";